import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Address() {
  const navigate = useNavigate();
  const [selectedAddress, setSelectedAddress] = useState<number | null>(null);
  const [showAddAddress, setShowAddAddress] = useState(false);

  const savedAddresses = [
    { id: 1, title: 'المنزل', address: 'شارع الملك فهد، حي النخيل، الرياض', isDefault: true },
    { id: 2, title: 'العمل', address: 'طريق الملك عبدالعزيز، حي العليا، الرياض', isDefault: false }
  ];

  return (
    <div className="min-h-screen bg-[#F6F6F6] pb-24" style={{ fontFamily: 'Cairo, sans-serif' }}>
      {/* Top Navigation */}
      <div className="fixed top-0 left-0 right-0 bg-white z-50 shadow-sm">
        <div className="px-4 py-4 flex items-center gap-3">
          <button onClick={() => navigate('/cart')} className="w-10 h-10 flex items-center justify-center">
            <i className="ri-arrow-right-line text-[#212121] text-2xl"></i>
          </button>
          <h1 className="text-[#212121] text-lg font-bold">عنوان التوصيل</h1>
        </div>
      </div>

      {/* Content */}
      <div className="pt-20 px-4">
        {/* Map */}
        <div className="bg-white rounded-2xl overflow-hidden shadow-sm mb-4 h-64">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3624.2!2d46.7!3d24.7!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjTCsDQyJzAwLjAiTiA0NsKwNDInMDAuMCJF!5e0!3m2!1sen!2ssa!4v1234567890"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
          ></iframe>
        </div>

        {/* Saved Addresses */}
        <div className="mb-4">
          <h2 className="text-[#212121] font-bold mb-3">العناوين المحفوظة</h2>
          <div className="space-y-3">
            {savedAddresses.map((addr) => (
              <button
                key={addr.id}
                onClick={() => setSelectedAddress(addr.id)}
                className={`w-full bg-white rounded-2xl p-4 text-right transition-all ${
                  selectedAddress === addr.id ? 'border-2 border-[#0D47A1]' : 'border-2 border-transparent'
                }`}
              >
                <div className="flex items-start justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <i className={`${addr.title === 'المنزل' ? 'ri-home-4-fill' : 'ri-building-fill'} text-[#0D47A1] text-xl`}></i>
                    <span className="text-[#212121] font-bold">{addr.title}</span>
                    {addr.isDefault && (
                      <span className="bg-[#4CAF50] text-white text-xs px-2 py-0.5 rounded-full">افتراضي</span>
                    )}
                  </div>
                  <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${
                    selectedAddress === addr.id ? 'border-[#0D47A1]' : 'border-gray-300'
                  }`}>
                    {selectedAddress === addr.id && (
                      <div className="w-3 h-3 bg-[#0D47A1] rounded-full"></div>
                    )}
                  </div>
                </div>
                <p className="text-gray-600 text-sm">{addr.address}</p>
              </button>
            ))}
          </div>
        </div>

        {/* Add New Address */}
        <button
          onClick={() => setShowAddAddress(true)}
          className="w-full bg-white border-2 border-dashed border-[#0D47A1] rounded-2xl p-4 text-[#0D47A1] font-bold flex items-center justify-center gap-2 mb-4"
        >
          <i className="ri-add-circle-line text-xl"></i>
          إضافة عنوان جديد
        </button>

        {/* Delivery Notes */}
        <div className="bg-white rounded-2xl p-5">
          <h3 className="text-[#212121] font-bold mb-3">ملاحظات التوصيل</h3>
          <textarea
            placeholder="أضف ملاحظات للمندوب (اختياري)"
            className="w-full h-24 p-3 bg-[#F6F6F6] rounded-xl text-sm resize-none focus:outline-none focus:ring-2 focus:ring-[#0D47A1]"
            maxLength={500}
          ></textarea>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 z-50">
        <button
          onClick={() => navigate('/quotes')}
          disabled={!selectedAddress}
          className={`w-full py-4 rounded-xl font-bold text-lg shadow-lg active:scale-95 transition-transform ${
            selectedAddress
              ? 'bg-gradient-to-r from-[#0D47A1] to-[#1976D2] text-white'
              : 'bg-gray-300 text-gray-500 cursor-not-allowed'
          }`}
        >
          متابعة
        </button>
      </div>

      {/* Add Address Modal */}
      {showAddAddress && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-end" onClick={() => setShowAddAddress(false)}>
          <div className="bg-white w-full rounded-t-3xl p-6 max-h-[80vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="w-12 h-1 bg-gray-300 rounded-full mx-auto mb-6"></div>
            <h3 className="text-[#212121] text-lg font-bold mb-6">إضافة عنوان جديد</h3>
            
            <div className="space-y-4">
              <div>
                <label className="text-gray-700 text-sm font-medium mb-2 block">عنوان المكان</label>
                <input
                  type="text"
                  placeholder="مثال: المنزل، العمل"
                  className="w-full px-4 py-3 bg-[#F6F6F6] rounded-xl focus:outline-none focus:ring-2 focus:ring-[#0D47A1]"
                />
              </div>
              
              <div>
                <label className="text-gray-700 text-sm font-medium mb-2 block">العنوان الكامل</label>
                <textarea
                  placeholder="الشارع، الحي، المدينة"
                  className="w-full h-24 px-4 py-3 bg-[#F6F6F6] rounded-xl resize-none focus:outline-none focus:ring-2 focus:ring-[#0D47A1]"
                  maxLength={500}
                ></textarea>
              </div>

              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="text-gray-700 text-sm font-medium mb-2 block">رقم المبنى</label>
                  <input
                    type="text"
                    placeholder="1234"
                    className="w-full px-4 py-3 bg-[#F6F6F6] rounded-xl focus:outline-none focus:ring-2 focus:ring-[#0D47A1]"
                  />
                </div>
                <div>
                  <label className="text-gray-700 text-sm font-medium mb-2 block">رقم الشقة</label>
                  <input
                    type="text"
                    placeholder="5"
                    className="w-full px-4 py-3 bg-[#F6F6F6] rounded-xl focus:outline-none focus:ring-2 focus:ring-[#0D47A1]"
                  />
                </div>
              </div>

              <button
                onClick={() => setShowAddAddress(false)}
                className="w-full bg-gradient-to-r from-[#0D47A1] to-[#1976D2] text-white py-4 rounded-xl font-bold shadow-lg active:scale-95 transition-transform"
              >
                حفظ العنوان
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}